export const CONTRIBUTIONS_GET_STARTED = "CONTRIBUTIONS.GET_STARTED";
export const CONTRIBUTIONS_GET_SUCCESS = "CONTRIBUTIONS.GET_SUCCESS";
export const CONTRIBUTIONS_GET_FAILURE = "CONTRIBUTIONS.GET_FAILURE";